import { render } from "./salary.vue?vue&type=template&id=84e3b6f6"
import script from "./salary.vue?vue&type=script&lang=js"
export * from "./salary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__